import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import uuid from 'uuid';
import { API_LINK } from '../../constants';
import { xapiRequest, xapiSuccess, xapiFailure } from '../reducers/xapi';
import {selectedProgram, selectedProgramId, selectedContentId, getSelectedThinktool} from '../selectors'



const API = `https://xapi.ramped4.com/data/xAPI/statements/`;

function* xapiAxios() {
  const state = yield select(fullState => fullState);
  const { xapiType, type } = state.xapiReducer;
  const uuidToSend = uuid(state.xapiReducer);
  const {
    token,
  } = state.loginReducer;
  let jsonPayload = null;
  console.log('XAPI LOGIN2', xapiType)
  switch (xapiType) {
    case 'login':
      return axios({
        method: 'post',
        url: API_LINK+'api/logAppData/'+state.loginReducer.user.userId,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${token}`,
        },
       
        credentials: 'same-origin',
        data: {
          platform: 'web', 
          verb: 'LoggedIn'
        },
      });
    case 'registration':
      return axios({
        method: 'post',
        url: API_LINK+'api/logAppData/'+state.loginReducer.user.userId,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${token}`,
        },
       
        credentials: 'same-origin',
        data: {
          platform: 'web', 
          verb: 'Registration'
        },
      });
      break;
    case 'StartedImage':
    case 'Started':
      return axios({
        method: 'post',
        url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${token}`,
        },
       
        credentials: 'same-origin',
        data: {
          platform: 'web', 
          verb: 'Started',
          component_id: selectedContentId(state),
          module_id: getSelectedThinktool(state).module_id,
          rollout_id: selectedProgram(state).rolloutID
        },
      });
      break;
      case 'Opened':
        console.log('STATSXX2',getSelectedThinktool(state),selectedProgram(state))
          return axios({
            method: 'post',
            url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              Authorization: `Bearer ${token}`,
            },
           
            credentials: 'same-origin',
            data: {
              platform: 'web', 
              verb: 'Opened',
              component_id: selectedContentId(state),
              module_id: getSelectedThinktool(state).module_id,
              rollout_id: selectedProgram(state).rolloutID
            },
          });
          break;
          case 'Closed':
              return axios({
                method: 'post',
                url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  Authorization: `Bearer ${token}`,
                },
               
                credentials: 'same-origin',
                data: {
                  platform: 'web', 
                  verb: 'Closed',
                  component_id: selectedContentId(state),
                  module_id: getSelectedThinktool(state).module_id,
                  rollout_id: selectedProgram(state).rolloutID
                },
              });
              break;
    case 'Completed':
      return axios({
        method: 'post',
        url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${token}`,
        },
       
        credentials: 'same-origin',
        data: {
          platform: 'web', 
          verb: 'Completed',
          component_id: selectedContentId(state),
          module_id: getSelectedThinktool(state).module_id,
          rollout_id: selectedProgram(state).rolloutID
        },
      });
      break;
    case 'CompletedImage':
    case 'Submitted':
      return axios({
        method: 'post',
        url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${token}`,
        },
       
        credentials: 'same-origin',
        data: {
          platform: 'web', 
          verb: 'Submitted',
          component_id: selectedContentId(state),
          module_id: getSelectedThinktool(state).module_id,
          rollout_id: selectedProgram(state).rolloutID
        },
      });
      break;
      case 'Saved':
          return axios({
            method: 'post',
            url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              Authorization: `Bearer ${token}`,
            },
           
            credentials: 'same-origin',
            data: {
              platform: 'web', 
              verb: 'Saved',
              component_id: selectedContentId(state),
              module_id: getSelectedThinktool(state).module_id,
              rollout_id: selectedProgram(state).rolloutID
            },
          });
          break;
      case 'Read':
          return axios({
            method: 'post',
            url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              Authorization: `Bearer ${token}`,
            },
           
            credentials: 'same-origin',
            data: {
              platform: 'web', 
              verb: 'Read',
              message_id: state.messageContentReducer.selectedMessageId,
              module_id: getSelectedThinktool(state).module_id,
              rollout_id: selectedProgram(state).rolloutID
            },
          });
          break;
          case 'Sent':
              return axios({
                method: 'post',
                url: API_LINK+'api/logCoachData/'+state.loginReducer.user.userId,
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  Authorization: `Bearer ${token}`,
                },
               
                credentials: 'same-origin',
                data: {
                  platform: 'web', 
                  verb: 'Sent',
                  message_id: state.messageContentReducer.selectedMessageId,
                  module_id: getSelectedThinktool(state).module_id,
                  rollout_id: selectedProgram(state).rolloutID
                },
              });
              break;
   
    default:
      jsonPayload = null;
      break;
  }
  const body = JSON.stringify(jsonPayload);
  // return yield call(() =>
  //   axios({
  //     method: 'post',
  //     url: API,
  //     headers: {
  //       Accept: 'application/json, text/plain, */*',
  //       'Content-Type': 'application/json',
  //       Authorization:
  //         'Basic MjM2MTI5MjJlZGM0NDBhM2E1ZDgwNDc3NjI4ODBiNjZkOGQ1OWEzODo5YmVlZWU5MzhhNDIwYmI5NjQ2Mzk0NmE0OWFkOTY5YjI5YzA1YmVh',
  //       'X-Experience-API-Version': '1.0.1',
  //     },
  //     data: body,
  //   }),
  // );
  return null
}

function* workerXapiSaga() {
  try {
    const response = yield call(xapiAxios);
    const responseData = response.data;

    if (response.status === 200) {
      yield put(xapiSuccess(responseData));
    }
  } catch (error) {
    yield put(xapiFailure(error.response));
  }
}

export function* watcherXapiSaga() {
  yield takeLatest(xapiRequest().type, workerXapiSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_xapi.js